// extracted by mini-css-extract-plugin
export default {"settings__input":"styles_settings__input__vzp4O","settings__row":"styles_settings__row__-bdbK"};